import React, { useCallback, useEffect, useRef } from 'react';
import usePrevious from 'hooks/usePrevious';
import ClipSelectDetailCard from '../ClipSelectDetailCard';
import { ClipSelectDetailCardInstance } from '../ClipSelectDetailCard/ClipSelectDetailCard';

export interface ClipSelectDetailCardSlideProps {
  id: number;
  isActive: boolean;
  autoPlay: boolean;
  onPlaybackChange: (isPlaying: boolean) => void;
}

const ClipSelectDetailCardSlide: React.FC<ClipSelectDetailCardSlideProps> = ({
  id,
  isActive,
  autoPlay,
  onPlaybackChange,
}) => {
  const cardRef = useRef<ClipSelectDetailCardInstance>(null);
  const prevIsActive = usePrevious(isActive);

  const handlePlaybackChange = useCallback(
    (newIsPlaying: boolean): void => {
      if (!isActive) {
        return;
      }

      onPlaybackChange(newIsPlaying);
    },
    [isActive, onPlaybackChange],
  );

  useEffect(() => {
    if (prevIsActive !== isActive) {
      if (isActive && autoPlay) {
        cardRef.current?.play();
      }

      if (!isActive && cardRef.current?.isPlaying) {
        cardRef.current?.pause();
      }
    }
  }, [autoPlay, isActive, prevIsActive]);

  return (
    <ClipSelectDetailCard
      ref={cardRef}
      id={id}
      onPlaybackChange={handlePlaybackChange}
    />
  );
};

export default ClipSelectDetailCardSlide;
